/**
 * The Connect page's one search parameter — `?example=curl|fetch` — on its own, so the
 * two route files can declare it without importing the page.
 *
 * A route's `validateSearch` stays in the main chunk when its component is split off
 * (`vite.config.ts` `autoCodeSplitting`), and it takes the whole module it is imported
 * from with it: declared beside `ConnectPage`, the page and every section it draws
 * shipped with the shell. Here it costs the schema and nothing else
 * (`pages/blog/search.ts` is the same move).
 */

import { z } from 'zod'

import { routeSearch } from '../../search/useSearchState.js'

/** The two ways an example request is written. */
export const EXAMPLE_STYLES = ['curl', 'fetch'] as const
export type ExampleStyle = (typeof EXAMPLE_STYLES)[number]

/**
 * How the examples are written. Absent is `curl`, which is what a developer pastes first
 * to see a request work at all.
 */
export const ConnectSearchSchema = z.object({ example: z.enum(EXAMPLE_STYLES).optional() })

/** Both routes' `validateSearch` — `routeSearch`, the one spelling every route uses. */
export const parseConnectSearch = routeSearch(ConnectSearchSchema)
